let pedido={
    plan:'none',
    precio:'none',
    min:'none',
    max:'none',
    total:'none',
    cantidad:'none',
    comidas:{},
    adicionales:{}
}, totalLeft = 'none';

$(function () { 
    actions();
    snd();
});

function snd() {
    
    $('.w-snd').on('click',function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        console.log('pedido: ',pedido);

        var frm = $('.rca');

        var dat = frm.find(":input").filter(function (index, element) {
            return !$(element).hasClass('optional') || ($(element).hasClass('optional') && $(element).val().length > 1)
        }).serialize();

        if(!obtenerDatosAdicionales()) return 0; 
        storeRegister();
    });
}
const storeRegister = () => {

    addOverlay();

    const _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    fetch(`/cart`, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': _token,
            'Accept': 'application/json',
            'Content-type':'application/json'
        },
        body: JSON.stringify(pedido)
    })
    .then(response => response.json())
    .then((response) => {
            if (response.custom_error) {
                mensajeError(response);
            }else if (response.errors) {
                const  lbl_error= document.querySelector('.mensaje-error');
                lbl_error.classList.add("d-none");
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

                removeOverlay();

                Swal.fire({
                    title: 'Atención',
                    text: 'Compruebe los campos marcados',
                    showCancelButton: false,
                    icon: 'warning',
                    confirmButtonColor: '#db133b',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
        
                for (const prop in response.errors) {
                    const el = document.querySelector('.pedido-error');
                    el.classList.remove("d-none");
                    el.innerHTML+=response.errors[prop][0];
                }
            }else {
                window.location = response.data.redirect;
            }
    })
    .catch((error) => {
        console.log(error);
    });
}


getDetails=(p, q)=>{

    const _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    let criteria = {
        pl: p,
        qt:q
    };

    fetch(`/product-details`, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': _token,
            'Accept': 'application/json',
            'Content-type':'application/json'
        },
        body: JSON.stringify(criteria)
    })
    .then(response => response.json())
    .then((response) => {
            if (response.custom_error) {
                mensajeError(response);
            } else {
              mealsCounter(response.data.price);
            }
    })
    .catch((error) => {
        console.log(error);
    });

}


function actions() {

    $(document).on('click','.meal-plan',function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        resetCart();

        var plan = $(this).data('plan');
        pedido.plan=plan;

        pedido.cantidad = parseInt($(this).data('min'));
        $('.meal-number').data('qty',pedido.cantidad);
        $('.meal-number').html(pedido.cantidad);

        pedido.min = parseInt($(this).data('min'));
        pedido.max = parseInt($(this).data('max'));
        $('#max-meal').html(pedido.max);

        $('#num-comidas').html(pedido.cantidad);
        totalLeft = pedido.cantidad;

        getDetails(pedido.plan, pedido.cantidad);

        $(this).data('price',pedido.precio);

        pedido.precio=parseFloat($(this).data('price'));

        $('.meal-plan').removeClass('on');
        $(this).addClass('on');
        $('.meal-kind').html($(this).data('name'));
        mealsCounter(pedido.precio);

        // var ix2 = Webflow.require('ix2').init();
        // $(document).find('div.paquete-card').css('filter','grayscale(100%)').removeClass('active-on');
        // $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
    });

    $(document).on('click','.i-add',function(e) {
        e.preventDefault();
        e.stopPropagation();

        if(!isNaN(pedido.plan)) {

            if(totalLeft>0) {

                var el=$(this).data('node');
                var refId=$(this).data('comida');
                
                var counter = $('#'+el).find('input[name="'+el+'"]');
                var labelTitle = $('#'+el).find('h3.mc-title').html();

                var valor = parseInt(counter.val())+1;

                totalLeft = parseInt(totalLeft)-1;

                counter.val(valor);
                pedido['comidas'][el]={id:refId,cantidad:valor,nombre:labelTitle};
                $('#num-comidas').html(totalLeft);
                $('#'+el).find('div.counter-num').html('<div>'+counter.val()+'</div>');

            }else{
                let message="Total de comidas completo";
                mensajeSimple(message);
            }

        }else{
            let message="No se ha seleccionado el Objetivo del Menú";
            mensajeSimple(message);
            var ix2 = Webflow.require('ix2').init();
            $(document).find('div.paquete-card').css('filter','grayscale(100%)');
            $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
        }
    });

    $(document).on('click','.i-remove',function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if(!isNaN(pedido.plan)) {

            if(totalLeft<pedido.cantidad) {

                var el = $(this).data('node');
                var refId=$(this).data('comida');
                
                var counter = $('#'+el).find('input[name="'+el+'"]');
                var labelTitle = $('#'+el).find('h3.mc-title').html();

                if(parseInt(counter.val())===0) return;

                var valor = parseInt(counter.val())-1;

                totalLeft = parseInt(totalLeft)+1;

                counter.val(valor);
                pedido['comidas'][el]={id:refId,cantidad:valor,nombre:labelTitle};
                if(valor===0) delete pedido['comidas'][el];
                $('#num-comidas').html(totalLeft);
                $('#'+el).find('div.counter-num').html('<div>'+counter.val()+'</div>');

            }else{
                let message="Revisar las comidas disponibles";
                mensajeSimple(message);
            }

        }else{
            let message="No se ha seleccionado el Objetivo del Menú";
            mensajeSimple(message);
            var ix2 = Webflow.require('ix2').init();
            $(document).find('div.paquete-card').css('filter','grayscale(100%)');
            $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
        }
    });

    $(document).on('click','.remove-meal',function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if(!isNaN(pedido.plan)) {

            if(pedido.cantidad>pedido.min && totalLeft>0) {

                pedido.cantidad--;
                totalLeft = parseInt(totalLeft) - 1;
                
                getDetails(pedido.plan, pedido.cantidad);
                mealsCounter(pedido.precio);

                $('.meal-number').data('qty',pedido.cantidad);
                $('.meal-number').html(pedido.cantidad);

                $('#num-comidas').html(totalLeft);

            }else{
                let message="Revisar el mínimo de comidas a seleccionar o ya seleccionadas";
                mensajeSimple(message,'warning');
            }

        }else{
            let message="No se ha seleccionado el Objetivo del Menú";
            mensajeSimple(message,'warning');
            var ix2 = Webflow.require('ix2').init();
            $(document).find('div.paquete-card').css('filter','grayscale(100%)');
            $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
        }
    });

    $(document).on('click','.add-meal',function(e) {
        e.preventDefault();
        e.stopPropagation();

        if(!isNaN(pedido.plan)) {

            if (pedido.cantidad < pedido.max) {
                
                pedido.cantidad++;
                totalLeft = parseInt(totalLeft) + 1;
        
                getDetails(pedido.plan, pedido.cantidad);
                mealsCounter(pedido.precio);
                
                $('.meal-number').data('qty',pedido.cantidad);
                $('.meal-number').html(pedido.cantidad);

                $('#num-comidas').html(totalLeft);
            }else{
                let message="Revisar el máximo de comidas a seleccionar";
                mensajeSimple(message,'warning');
            }

        }else{
            let message="No se ha seleccionado el Objetivo del Menú";
            mensajeSimple(message);
            var ix2 = Webflow.require('ix2').init();
            $(document).find('div.paquete-card').css('filter','grayscale(100%)');
            $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
        }
    });

    $(document).on('change','.change',function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if(!isNaN(pedido.plan)) {

            var referencia=$(this).val();
            var activar=$('.otro');

            if(activar.data('ref')===referencia){
                activar.css('display','block').prop("disabled", false);
            }else{
                $('.otro').css('display','none').prop("disabled", true);
            }

        }else{
            let message="No se ha seleccionado el Objetivo del Menú";
            mensajeSimple(message);
            var ix2 = Webflow.require('ix2').init();
            $(document).find('div.paquete-card').css('filter','grayscale(100%)');
            $(document).find('div.circle-switc').css({transform: "translate3d(0px, 0px, 0px)"});
            return;
        }
    });    
}

function obtenerDatosAdicionales() {
    
        //var alimentos=$('div.menu-block').find('input');
        //pedido['comidas']={};
        //$.each(alimentos,function(i,val){
          //  if(val.value>0) pedido['comidas'][val.name]={cantidad:val.value};
       // });
        
        var check=0;
        
        $.each(pedido['comidas'],function(i,val){
           check+=val.cantidad;
        });

        if(check!==pedido.cantidad || totalLeft!==0) { 
            let message='No se han aplicado todas las comidas.';
            mensajeSimple(message);
            return;
        }

        var productosAdiconales = $(document).find('input.adicional');
        
        $.each(productosAdiconales,function(i,val){
            if (val.value>0) {
                var refId = val.dataset.adicional;
                var refName = val.dataset.name;
                var refCantidad = val.value;
                pedido['adicionales'][refId]={id:refId,cantidad:refCantidad,nombre:refName};
            } else {
                delete pedido['adicionales'][val.dataset.adicional];
            }

        });

        // var checkCode=$(document).find('input[name="codigo"]').val();
        // if(checkCode.length) { pedido['codigo']=checkCode; } else { delete pedido['codigo']; }

        return true;
}

resetCart=()=> {
    pedido.cantidad="";
    pedido.precio="";
    pedido.min="";
    pedido.max="";
    pedido.total="";
    pedido.comidas = {};
    pedido.adicionales = {};
    totalLeft='none';
    $('#num-comidas').html('');
    $('div.menu-block').find('input').val(0);
    $('div.menu-block').find('div.counter-num').html('<div>0</div>');
}

mealsCounter = (value) => {
    pedido.precio = value;
    pedido.total = pedido.precio * pedido.cantidad;
    $('.meals-price>strong').html(formatCurrency(pedido.precio));
    $('.total-meals>strong').html(formatCurrency(pedido.total));
}

formatCurrency=(number)=> {
  return number.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
}

mensajeSimple = (info,type='info') => {
    return Swal.fire({
        title: 'Atención',
        icon:type,
        text: info,
        showCancelButton: false,
        confirmButtonColor: '#db133b',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        allowEscapeKey: false
    });
}

mensajeError = (info) => {
    const lbl_error = document.querySelector('.mensaje-error');
    lbl_error.classList.add("d-none");
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    removeOverlay();

    return Swal.fire({
        title: 'Atención',
        text: info.custom_error.message[0],
        showCancelButton: false,
        icon: 'warning',
        confirmButtonColor: '#db133b',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        allowEscapeKey: false
    });
}

function addOverlay() {
    const el = document.querySelector('#overlay-cover');
    el.classList.remove("d-none");
}

function removeOverlay() {
    const el = document.querySelector('#overlay-cover');
    el.classList.add("d-none");
}